import { Action } from '@wix/component-protocol/schema';
import {
  IActionPanelAPI,
  NativeActionsList,
} from '@wix/editor-platform-host-integration-apis';
import { PlatformContext } from '../types';
import { isNativeStylesActionName } from '../utils';
import { GlobalDesignActionPanelAPI } from './GlobalDesignActionPanelAPI';
import { CustomActionPanelAPI } from './CustomActionPanelAPI';
import { GenericActionPanelAPI } from './GenericActionPanelAPI';
import { EditTextActionPanelAPI } from './EditTextActionPanelAPI';
import { SettingsActionPanelAPI } from './SettingsActionPanelAPI';
import { IExecutionContext } from './types';
import { PresetsActionPanelAPI } from './PresetsActionPanelAPI';
import { DisplayElementsActionPanelAPI } from './DisplayElementsActionPanelAPI';

export function createActionPanelAPI(
  action: Action,
  actionName: string,
  context: PlatformContext,
  executionContext?: IExecutionContext,
): IActionPanelAPI {
  if (
    (action.execution?.data ||
      action.execution?.cssProperty ||
      action.execution?.cssCustomProperty ||
      action.execution?.displayGroup) &&
    executionContext
  ) {
    return new CustomActionPanelAPI(
      action,
      actionName,
      executionContext,
      context,
    );
  }
  if (actionName === NativeActionsList.settings) {
    return new SettingsActionPanelAPI(context.editorPointers);
  }
  if (actionName === NativeActionsList.editText) {
    return new EditTextActionPanelAPI(context);
  }
  if (actionName === NativeActionsList.presets) {
    return new PresetsActionPanelAPI(context);
  }

  if (actionName === NativeActionsList.elements) {
    return new DisplayElementsActionPanelAPI(context);
  }

  if (isNativeStylesActionName(actionName)) {
    return new GlobalDesignActionPanelAPI(
      context.editorPointers,
      actionName,
      context.editorPointerAPI,
      context.componentsAPI,
    );
  }

  return new GenericActionPanelAPI(context.editorPointers, action, actionName);
}
